module.exports = __webpack_public_path__ + "img/27_28.9aea504b.png";